import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Users, CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { submitForm } from '../utils/googleSheets';
const teamMembers = [{
  name: 'חיליק בן ארי',
  role: 'בעלים ומנכ"ל',
  description: 'מה שצריך צריך',
  image: 'https://cdn.magicpatterns.com/uploads/cecfzHhRRwNr4mA7vfMWq9/IMG-20251210-WA0046.jpg'
}, {
  name: 'עמית גורפינקל',
  role: 'חותר אולימפי לשעבר',
  description: 'מדריך סרפסקי מוסמך ותותח',
  image: 'https://cdn.magicpatterns.com/uploads/pkzar27jAH2ucorPUZWRki/עמית.jpg'
}, {
  name: 'נחום שחר',
  role: 'מדריך וינג פויל וסאפ',
  description: 'ייקח אתכם לקצה ויעזור לך להבין שהכל אפשרי. מטפל ומלווה אנשים מעל 25 שנה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iW5tDwJ2HUr46iGT1Z7jZf/20250720_151627~2.jpg'
}, {
  name: 'עדי שמעוני',
  role: 'מדריכת סאפ',
  description: 'מחברת בין ים, קצב ונשימה — תמיד עם אנרגיה גבוהה, דואגת שכל חתירה תהיה מסע מעצים לגוף ולנשמה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g3L2o1s7VgiojWaLHWmHmc/IMG-20251202-WA0026_%281%29.jpg'
}, {
  name: 'אושרת ישורון',
  role: 'הלב הפועם של המועדון',
  description: 'תמיד עם חיוך ומילה טובה תקבל את פניכם במשרד עם ים אהבה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3ya3KhkEpguPp1yNngSd5U/IMG-20251202-WA0023_%281%29.jpg'
}];
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    type: 'success' | 'error' | null;
    message: string;
  }>({
    type: null,
    message: ''
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({
      type: null,
      message: ''
    });
    try {
      const result = await submitForm({
        ...formData,
        type: 'צור קשר',
        source: 'דף הבית - צור קשר'
      });
      if (result.success) {
        setSubmitStatus({
          type: 'success',
          message: 'תודה! הפנייה שלך נשלחה בהצלחה. ניצור איתך קשר בקרוב.'
        });
        // ניקוי הטופס
        setFormData({
          name: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        setSubmitStatus({
          type: 'error',
          message: result.message
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'אירעה שגיאה בשליחת הפנייה. אנא נסה שוב.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  return <>
      {/* Team Section */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white" data-id="element-50">
        <div className="container mx-auto px-4" data-id="element-51">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-52">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-53">
              <Users className="w-10 h-10 text-[#0A5F8F]" data-id="element-54" />
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F]" data-id="element-55">
                הצוות שלנו
              </h2>
            </div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-56">
              הכירו את האנשים שעושים את הקסם
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-57">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-58">
                <div className="text-center" data-id="element-59">
                  {member.image ? member.name === 'נחום שחר' ? <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-60">
                        <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 20%'
                }} data-id="element-61" />
                      </div> : member.name === 'עדי שמעוני' ? <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-62">
                        <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 3%'
                }} data-id="element-63" />
                      </div> : <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-64">
                        <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 15%'
                }} data-id="element-65" />
                      </div> : <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold" data-id="element-66">
                      {member.name.charAt(0)}
                    </div>}
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-67">
                    {member.name}
                  </h3>
                  <p className="text-[#0A5F8F] font-semibold mb-4" data-id="element-68">
                    {member.role}
                  </p>
                  <p className="text-gray-600 leading-relaxed" data-id="element-69">
                    {member.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-70">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-71" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-72">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-73">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-74">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-75">
                בואו לבקר אותנו
              </h2>
              <p className="text-blue-100 text-lg mb-12 max-w-md" data-id="element-76">
                אנחנו נמצאים בחוף מעגן, בפינה השקטה והיפה ביותר של הכנרת. הצוות
                שלנו מחכה לכם!
              </p>

              <div className="space-y-8" data-id="element-77">
                <div className="flex items-start gap-4" data-id="element-78">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-79">
                    <MapPin className="w-6 h-6" data-id="element-80" />
                  </div>
                  <div data-id="element-81">
                    <h3 className="font-bold text-xl mb-1" data-id="element-82">כתובת</h3>
                    <p className="text-blue-100" data-id="element-83">חוף מעגן, קיבוץ מעגן</p>
                    <p className="text-blue-100" data-id="element-84">עמק הירדן</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-85">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-86">
                    <Phone className="w-6 h-6" data-id="element-87" />
                  </div>
                  <div data-id="element-88">
                    <h3 className="font-bold text-xl mb-1" data-id="element-89">טלפון</h3>
                    <p className="text-blue-100" dir="ltr" data-id="element-90">
                      052-2632784
                    </p>
                    <p className="text-blue-100" dir="ltr" data-id="element-91">
                      053-3343172
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-92">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-93">
                    <Clock className="w-6 h-6" data-id="element-94" />
                  </div>
                  <div data-id="element-95">
                    <h3 className="font-bold text-xl mb-1" data-id="element-96">שעות פעילות</h3>
                    <p className="text-blue-100" data-id="element-97">
                      מדי יום מהשעה 6:00 ועד שעת החשיכה
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl text-gray-900" initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-98">
              <h3 className="text-2xl font-bold mb-6 text-[#0A5F8F]" data-id="element-99">
                השאירו פרטים
              </h3>

              {/* Success/Error Message */}
              {submitStatus.type && <div className={`mb-6 p-4 rounded-xl flex items-start gap-3 ${submitStatus.type === 'success' ? 'bg-green-50 text-green-800 border border-green-200' : 'bg-red-50 text-red-800 border border-red-200'}`} data-id="element-100">
                  {submitStatus.type === 'success' ? <CheckCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-101" /> : <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-102" />}
                  <p className="text-sm" data-id="element-103">{submitStatus.message}</p>
                </div>}

              <form className="space-y-6" onSubmit={handleSubmit} data-id="element-104">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-105">
                  <div className="space-y-2" data-id="element-106">
                    <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-107">
                      שם מלא
                    </label>
                    <input type="text" id="name" required value={formData.name} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="ישראל ישראלי" data-id="element-108" />
                  </div>
                  <div className="space-y-2" data-id="element-109">
                    <label htmlFor="phone" className="text-sm font-medium text-gray-700" data-id="element-110">
                      טלפון
                    </label>
                    <input type="tel" id="phone" required value={formData.phone} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="050-0000000" data-id="element-111" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-112">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-113">
                    אימייל
                  </label>
                  <input type="email" id="email" required value={formData.email} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="your@email.com" data-id="element-114" />
                </div>

                <div className="space-y-2" data-id="element-115">
                  <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-116">
                    הודעה
                  </label>
                  <textarea id="message" rows={4} required value={formData.message} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white resize-none disabled:opacity-50 disabled:cursor-not-allowed" placeholder="אני מעוניין לשמוע עוד על..." data-id="element-117" />
                </div>

                <Button type="submit" disabled={isSubmitting} className="w-full text-lg shadow-lg shadow-blue-500/30 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-118">
                  {isSubmitting ? 'שולח...' : 'שלח הודעה'}
                </Button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}